module.exports = __webpack_public_path__ + "static/media/estilo1.e4c091d3.png";